import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

export default {
	black,
	white,
	primary: {
		contrastText: white,
		dark: '#070C35',
		main: '#70D6D9',
		light: '#E0B080'
	},
	secondary: {
		contrastText: white,
		dark: colors.blue[900],
		main: colors.blue.A400,
		light: colors.blue.A400
	},
	error: {
		contrastText: white,
		dark: colors.red[900],
		main: colors.red[600],
		light: colors.red[400]
	},
	text: {
		primary: '#070C35',
		secondary: colors.blueGrey[600],
		link: colors.blue[600]
	},
	link: colors.blue[800],
	icon: colors.blueGrey[600],
	background: {
		main: '#DDE9E6',
		default: '#F4F6F8',
		paper: white
	},
	divider: colors.grey[200]
};
